<template>
  <div id="expediente_electronico_manifestacion">
    <div>
      <v-breadcrumbs :items="breadcrumbs">
        <v-icon slot="divider">forward</v-icon>
      </v-breadcrumbs>
    </div>

    <v-container fluid fill-height>
      <v-layout align-center justify-center>
        <v-flex xs12>
          <base-material-card
            color="primary"
            icon="library_books"
            title="EXPEDIENTE ELECTRÓNICO MANIFESTACIÓN"
            class="elevation-1 px-5 py-3"
          >
            <v-tabs grow style="margin-bottom: 30px;">
              <v-tabs-slider color="primary"></v-tabs-slider>
              <v-tab :key="'in-view'">EXPEDIENTES CARGADOS</v-tab>
              <v-tab :key="'in-logs'" @click="consultar_logs"
                >REGISTRO DE ERRORES</v-tab
              >
              <v-tab-item :key="'in-view'">
                <v-card-text>
                  <v-card-title>
                    <span class="headline"></span>
                  </v-card-title>
                  <v-form ref="form" lazy-validation>
                    <v-container grid-list-md text-xs-center>
                      <v-layout row wrap>
                        <v-flex x12 s6 m6 l6> </v-flex>
                      </v-layout>
                      <v-layout row wrap>
                        <v-flex s12 m4 l4>
                          <v-menu
                            offset-x
                            ref="menu1"
                            v-model="menu1"
                            :close-on-content-click="false"
                            transition="scale-transition"
                            min-width="290px"
                            offset-y
                          >
                            <template v-slot:activator="{ on }">
                              <v-text-field
                                v-on="on"
                                v-model="model.fecha_de"
                                label="Fecha Inicial"
                                color="secondary"
                                prepend-icon="event"
                                @blur="
                                  model.fecha_de = parseDate(model.fecha_de)
                                "
                                v-mask="'####-##-##'"
                                :rules="[
                                  rules.required,
                                  validaAnio,
                                  validaFecha
                                ]"
                              >
                              </v-text-field>
                            </template>
                            <v-date-picker
                              v-model="model.fecha_de"
                              color="secondary"
                              scrollable
                              locale="es-mx"
                              @input="menu1 = false"
                            >
                              <v-spacer />

                              <v-btn
                                color="secondary"
                                x-small
                                @click="menu1 = false"
                              >
                                Cancelar
                              </v-btn>
                            </v-date-picker>
                          </v-menu>
                        </v-flex>
                        <v-flex s12 m4 l4>
                          <v-menu
                            offset-x
                            ref="menu2"
                            v-model="menu2"
                            :close-on-content-click="false"
                            transition="scale-transition"
                            min-width="290px"
                            offset-y
                          >
                            <template v-slot:activator="{ on }">
                              <v-text-field
                                v-on="on"
                                v-model="model.fecha_a"
                                label="Fecha Final"
                                color="secondary"
                                prepend-icon="event"
                                @blur="model.fecha_a = parseDate(model.fecha_a)"
                                v-mask="'####-##-##'"
                                :rules="[
                                  rules.required,
                                  validaAnio,
                                  validaFecha
                                ]"
                              >
                              </v-text-field>
                            </template>
                            <v-date-picker
                              v-model="model.fecha_a"
                              color="secondary"
                              scrollable
                              locale="es-mx"
                              @input="menu2 = false"
                            >
                              <v-spacer />

                              <v-btn
                                color="secondary"
                                x-small
                                @click="menu2 = false"
                              >
                                Cancelar
                              </v-btn>
                            </v-date-picker>
                          </v-menu>
                        </v-flex>
                        <v-flex s12 m2 l2>
                          <v-btn color="primary" @click="consultar">
                            <v-icon>search</v-icon>Consultar
                          </v-btn>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-form>

                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <exportar-excel
                      :data="datos"
                      :exportFields="camposExcelConsulta"
                      name="ExpedientesManifestacion.xlsx"
                    >
                      <v-btn
                        fab
                        dark
                        x-small
                        color="green darken-4"
                        title="Exportar Consulta"
                        v-tippy
                      >
                        <v-icon dark>get_app</v-icon>
                      </v-btn>
                    </exportar-excel>
                  </v-card-actions>
                  <v-client-table
                    ref="vuetable"
                    :data="datos"
                    :columns="columns"
                    :options="options"
                    class="elevation-2 pa-2"
                  >
                    <template slot="noResults">
                      <v-alert :value="true" icon="info" color="info">
                        No se encontró ningún registro</v-alert
                      >
                    </template>
                    <template slot="estatus" slot-scope="props">
                      {{ getEstatus(props.row.estatus) }}
                    </template>
                    <template slot="actions" slot-scope="props">
                      <v-btn
                        text
                        icon
                        color="primary"
                        title="Contenido"
                        @click="
                          model.pedimento = props.row.pedimento;
                          model.tipo_pedimento = props.row.tipo_pedimento;
                          model.id = props.row.id;
                          model.estatus = props.row.estatus;
                          cargarArchivos(props.row.id, props.row.estatus);
                        "
                      >
                        <v-icon dark>mdi-folder-search-outline</v-icon>
                      </v-btn>
                      <v-btn
                        v-if="false"
                        text
                        icon
                        color="primary"
                        title="Descargar"
                        @click="downloadFile(props.row.key)"
                      >
                        <v-icon dark>get_app</v-icon>
                      </v-btn>
                      <v-btn
                        text
                        icon
                        color="red"
                        v-if="props.row.estatus < 3 || permisoEliminar"
                        title="Eliminar"
                        @click="eliminarBandeja(props.row.id)"
                      >
                        <v-icon dark>delete</v-icon>
                      </v-btn>
                    </template>
                  </v-client-table>
                </v-card-text>
              </v-tab-item>
              <v-tab-item :key="'in-logs'">
                <v-card-text>
                  <v-card-title>
                    <span class="headline"></span>
                  </v-card-title>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <exportar-excel
                      :data="datos_logs"
                      :exportFields="camposExcelConsulta_logs"
                      name="LogsExpedientesManifestacion.xlsx"
                    >
                      <v-btn
                        fab
                        dark
                        x-small
                        color="green darken-4"
                        title="Exportar Consulta"
                        v-tippy
                      >
                        <v-icon dark>get_app</v-icon>
                      </v-btn>
                    </exportar-excel>
                  </v-card-actions>
                  <v-client-table
                    ref="vuetable"
                    :data="datos_logs"
                    :columns="columns_logs"
                    :options="options_logs"
                    class="elevation-2 pa-2"
                  >
                    <template slot="noResults">
                      <v-alert :value="true" icon="info" color="info">
                        No se encontró ningún registro</v-alert
                      >
                    </template>
                    <template slot="fecha" slot-scope="props">
                      {{ props.row.fecha.substring(0, 10) }}
                    </template>
                  </v-client-table>
                </v-card-text>
              </v-tab-item>
            </v-tabs>
          </base-material-card>
          <v-dialog v-model="dialog" max-width="1000px">
            <v-card>
              <v-card-actions>
                <h5>Contenido de {{ model.pedimento }}</h5>
                <v-chip class="ma-2" x-small>
                  {{ getEstatus(model.estatus) }}
                </v-chip>

                <v-spacer></v-spacer>

                <v-btn
                  small
                  color="success"
                  v-if="model.estatus < 3"
                  @click="procesarArchivos()"
                >
                  <v-icon small>mdi-cogs</v-icon>Ejecutar Reglas
                </v-btn>
                <v-btn
                  small
                  color="primary"
                  v-if="model.estatus == 2 || model.estatus == 6"
                  @click="enviar(model.id)"
                >
                  <v-icon small>mdi-folder</v-icon> Enviar al Expediente
                </v-btn>
                <v-btn
                  small
                  @click="
                    dialog = false;
                    consultar();
                  "
                >
                  <v-icon>cancel</v-icon>Cerrar
                </v-btn>
              </v-card-actions>
              <v-card-text>
                <v-client-table
                  ref="vuetable"
                  :data="archivos"
                  :columns="columns_archivos"
                  :options="options_archivos"
                  class="elevation-2 pa-2"
                >
                  <template slot="noResults">
                    <v-alert :value="true" icon="info" color="info">
                      No se encontro ningun registro</v-alert
                    >
                  </template>

                  <template slot="tipo_documento" slot-scope="props">
                    <div
                      v-if="model.estatus < 3 || model.estatus == 4"
                      @click="
                        editar_tipo.tipo = props.row.tipo_documento;
                        editar_tipo.nombre = props.row.nombre_original;
                        editar_tipo.ext = props.row.extension;
                        dialogTipos = true;
                      "
                      :class="
                        props.row.estatus == 4 ? 'showPerfil6' : 'showPerfil'
                      "
                    >
                      {{ getPrefijo(props.row.tipo_documento) }}
                    </div>
                    <div v-if="model.estatus > 2 && model.estatus != 4">
                      {{ getPrefijo(props.row.tipo_documento) }}
                    </div>
                  </template>
                  <template slot="estatus" slot-scope="props">
                    {{ getEstatus(props.row.estatus) }}
                  </template>

                  <template slot="actions" slot-scope="props">
                    <v-btn
                      text
                      icon
                      color="red"
                      title="Eliminar"
                      v-if="model.estatus < 3"
                      @click="
                        editar_tipo.nombre = props.row.nombre_original;
                        editar_tipo.ext = props.row.extension;
                        eliminarArchivo();
                      "
                    >
                      <v-icon dark>delete</v-icon>
                    </v-btn>
                  </template>
                </v-client-table>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-dialog v-model="dialogTipos" max-width="700px">
            <v-card>
              <v-card-title>
                <h5>Asignar Tipo de Documento</h5>
              </v-card-title>
              <v-card-text>
                <v-autocomplete
                  dense
                  clearable
                  :items="tiposDocumentos"
                  v-model="editar_tipo.tipo"
                  item-text="descripcion"
                  item-value="clave"
                  :rules="[rules.required]"
                  label="Tipo de Documento"
                  placeholder="Seleccione un Tipo de Documento"
                >
                  <template v-slot:item="data">
                    <template>
                      <v-list-item-content>
                        <v-list-item-title
                          v-html="
                            data.item.clave + ' - ' + data.item.descripcion
                          "
                        ></v-list-item-title>
                      </v-list-item-content>
                    </template>
                  </template>
                </v-autocomplete>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>

                <v-btn small @click="dialogTipos = false">
                  <v-icon>cancel</v-icon>Cerrar
                </v-btn>
                <v-btn
                  color="success"
                  small
                  @click="
                    dialogTipos = false;
                    actualizarTipo();
                  "
                >
                  <v-icon>done</v-icon>Guardar
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-flex>
      </v-layout>
    </v-container>

    <v-divider></v-divider>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
export default {
  data: () => ({
    camposExcelConsulta: {
      RFC: "rfc",
      Fecha: "fecha",
      Email: "email",
      Pedimento: "pedimento",
      "Tipo pedimento": "tipo_pedimento",
      Año: "anio",
      Origen: "origen",
      "Perfil usuario": "perfil_usuario",
      Archivo: "filename",
      Estatus: "estatus_nombre"
    },
    camposExcelConsulta_logs: {
      RFC: "rfc",
      Fecha: "fecha",
      Filename: "filename",
      Error: "error"
    },
    dialog: false,
    dialogTipos: false,
    tiposDocumentos: [],
    reglas: [],
    datos: [],
    datos_logs: [],
    archivos: [],
    refreshTabla: false,
    permisoEliminar: false,
    fab: false,
    breadcrumbs: [
      {
        text: "Inicio",
        disabled: false,
        to: "/home"
      },
      {
        text: "Manifestación",
        disabled: true,
        to: ""
      },
      {
        text: "EXPEDIENTE ELECTRÓNICO MANIFESTACIÓN",
        disabled: true,
        to: ""
      }
    ],

    validaContribucion: false,
    validaForma: false,

    columns: [
      "fecha",
      "email",
      "pedimento",
      "tipo_pedimento",
      "anio",
      "origen",
      "perfil_usuario",
      "filename",
      "estatus",
      "actions"
    ],
    columns_logs: ["rfc", "fecha", "filename", "error"],
    columns_archivos: [
      "nombre_original",
      "extension",
      "tipo_documento",
      "estatus",
      "actions"
    ],
    options_archivos: {
      orderBy: {
        column: "nombre_original",
        ascending: true
      },
      filterable: ["nombre_original", "extension", "tipo_documento", "estatus"],
      sortable: ["nombre_original", "extension", "tipo_documento", "estatus"],

      headings: {
        nombre_original: "Nombre",
        extension: "Extensión",
        tipo_documento: "Tipo",
        estatus: "Estatus",
        actions: ""
      }
    },
    options: {
      orderBy: {
        column: "id",
        ascending: false
      },
      filterByColumn: true,
      listColumns: {
        estatus: [
          {
            id: 0,
            text: "Pendiente"
          },
          {
            id: 1,
            text: "No Procesado"
          },
          {
            id: 2,
            text: "Correcto"
          },
          {
            id: 3,
            text: "Enviado"
          },
          {
            id: 4,
            text: "Autoasignado"
          },
          {
            id: 5,
            text: "Procesado"
          },
          {
            id: 6,
            text: "Procesado con Errores"
          }
        ]
      },
      filterable: [
        "fecha",
        "email",
        "pedimento",
        "tipo_pedimento",
        "anio",
        "origen",
        "perfil_usuario",
        "filename",
        "estatus"
      ],
      sortable: [
        "fecha",
        "email",
        "pedimento",
        "tipo_pedimento",
        "anio",
        "origen",
        "perfil_usuario",
        "filename",
        "estatus"
      ],

      headings: {
        fecha: "Fecha",
        email: "Email",
        pedimento: "Pedimento",
        tipo_pedimento: "Tipo Pedimento",
        anio: "Año",
        origen: "Origen",
        perfil_usuario: "Perfil",
        filename: "Archivo",
        estatus: "Estatus",
        actions: "Operaciones"
      }
    },
    options_logs: {
      filterByColumn: true,
      filterable: ["error", "fecha", "filename"],
      sortable: ["fecha", "filename", "error"],

      headings: {
        fecha: "Fecha",
        error: "Error",
        rfc: "RFC",
        filename: "Archivo"
      }
    },
    show_loading: true,

    model: {
      id: 0,
      rfc: "",
      usuario: "",
      fecha_de: "",
      fecha_a: "",
      pedimento: "",
      tipo_pedimento: "",
      aduana: "",
      patente: "",
      estatus: ""
    },
    editar_tipo: {
      nombre: "",
      ext: "",
      tipo: ""
    },
    menu1: false,
    menu2: false,

    rules: {
      required: v => !!v || "Este campo es requerido",
      numeric: value => {
        const pattern = /^[\d]*$/;
        return pattern.test(value) || "Solo se permiten números";
      }
    }
  }),

  methods: {
    validaFecha: function(fecha) {
      if (fecha == "Invalid date") return "Fecha no válida.";
      else return true;
    },
    validaAnio: function() {
      if (this.model.fecha_de != "" && this.model.fecha_a != "") {
        var inicio = moment(this.model.fecha_de, "YYYY-MM-DD");
        var fin = moment(this.model.fecha_a, "YYYY-MM-DD");
        var diferencia = fin.diff(inicio, "days");
        if (diferencia < 0)
          return "La Fecha Final no debe ser menor a la Fecha Inicial.";
      }
      return true;
    },
    getPrefijo: function(tipo) {
      var filtro = this.tiposDocumentos.filter(function(e) {
        return e.clave == tipo;
      });
      if (filtro.length > 0)
        return filtro[0].clave + "-" + filtro[0].descripcion.substring(0, 50);
      else return "Sin Asignar...";
    },
    actualizarTipo: function() {
      let self = this;
      var filtro = this.archivos.filter(function(e) {
        return (
          e.nombre_original == self.editar_tipo.nombre &&
          e.extension == self.editar_tipo.ext
        );
      });
      if (filtro.length > 0) {
        filtro[0].tipo_documento = self.editar_tipo.tipo;
        if (self.editar_tipo.tipo == undefined) {
          filtro[0].estatus = 1;
        } else {
          filtro[0].estatus = 2;
        }
        self.procesarArchivos();
      }
    },
    eliminarBandeja: function(idbandeja) {
      this.$swal({
        type: "info",
        title: "Cuidado",
        text: "¿Está seguro de eliminar el registro?",
        footer: "",
        showCancelButton: true,
        cancelButtonColor: "#d33",
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Aceptar",
        cancelButtonText: "Cancelar"
      }).then(result => {
        if (result.value) {
          this.$root.$dialogLoader.show("ESPERE UN MOMENTO POR FAVOR..");
          var datos = {
            id: idbandeja
          };
          axios
            .post(
              this.$hostname + "bandeja_temporal_manifestacion/eliminar/",
              datos
            )
            .then(res => {
              this.consultar();
              this.$swal({
                type: "success",
                title: "Operación Exitosa",
                text: "El reporte se eliminó correctamente",
                footer: ""
              });
            })
            .catch(error => {
              this.$swal({
                type: "error",
                title: "¡Operación no Permitida!",
                text:
                  "Ocurrió un error al eliminar el reporte. Favor de comunicarse con soporte.",
                footer: ""
              });
              console.log(error);
            })
            .then(() => {
              this.$root.$dialogLoader.hide();
            });
        }
      });
    },
    eliminarArchivo: function() {
      let self = this;
      var filtro = [];
      this.$swal({
        type: "info",
        title: "Cuidado",
        text: "¿Está seguro de eliminar el archivo?",
        footer: "",
        showCancelButton: true,
        cancelButtonColor: "#d33",
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Aceptar",
        cancelButtonText: "Cancelar"
      }).then(result => {
        if (result.value) {
          this.archivos.forEach(function(e) {
            if (
              !(
                e.nombre_original == self.editar_tipo.nombre &&
                e.extension == self.editar_tipo.ext
              )
            ) {
              filtro.push(e);
            }
          });

          self.archivos = filtro;
          self.procesarArchivos();
        }
      });
    },
    consultar: function() {
      this.$root.$dialogLoader.show("ESPERE UN MOMENTO POR FAVOR..");
      let data = {
        rfc: this.model.rfc,
        fecha_de: this.model.fecha_de,
        fecha_a: this.model.fecha_a
      };
      axios
        .post(this.URL + "bandeja_temporal_manifestacion/listar/", data)
        .then(res => {
          if (typeof res.data !== "undefined") {
            this.datos = res.data;
            this.datos.sort(function(a, b) {
              //Ordenar por fecha más reciente
              return new Date(b.fecha) - new Date(a.fecha);
            });
            for (var k in this.datos) {
              this.datos[k].fecha = this.parseDate(this.datos[k].fecha);
              this.datos[k]["estatus_nombre"] = this.getEstatus(
                this.datos[k].estatus
              );
              this.datos[k].tipo_pedimento =
                this.datos[k].tipo_pedimento == 1
                  ? "Importación"
                  : "Exportación";
            }
          }
        })
        .catch(err => {
          this.$swal({
            type: "error",
            title: "¡Operación no Permitida!",
            text: "Ocurrió un error al obtener los reportes ds.",
            footer: ""
          });
          console.log(err);
        })
        .then(() => {
          this.$root.$dialogLoader.hide();
        });
    },
    consultar_logs: function() {
      let data = {
        rfc: this.model.rfc
      };
      axios
        .post(this.URL + "bandeja_temporal_manifestacion/list_logs/", data)
        .then(res => {
          if (typeof res.data !== "undefined") {
            this.datos_logs = res.data;
            this.datos_logs.sort(function(a, b) {
              //Ordenar por fecha más reciente
              return new Date(b.fecha) - new Date(a.fecha);
            });
          }
        })
        .catch(err => {
          this.$swal({
            type: "error",
            title: "¡Operación no Permitida!",
            text: "Ocurrió un error al obtener los reportes ds.",
            footer: ""
          });
          console.log(err);
        })
        .then(() => {
          this.$root.$dialogLoader.hide();
        });
    },
    cargarArchivos: async function(id, estatus) {
      let self = this;
      this.archivos = [];
      this.$root.$dialogLoader.show("ESPERE UN MOMENTO POR FAVOR..");
      let data = {
        id: id
      };
      await axios
        .post(
          self.$hostname + "reglas/expediente_manifestacion/listar_reglas/",
          {
            rfc: self.$local_storage.get("rfc")
          }
        )
        .then(response => {
          self.reglas = response.data;
        })
        .catch(error => {
          console.log(error);
        });

      await axios
        .post(this.$hostname + "bandeja_temporal_manifestacion/detalles/", data)
        .then(response => {
          this.archivos = response.data;
          this.archivos = this.archivos.sort(function(a, b) {
            return a.nombre_original > b.nombre_original;
          });
          if (estatus < 3) {
            //0-Pendiente, 1-No Procesado
            self.procesarArchivos();
          }
          this.$root.$dialogLoader.hide();
        })
        .catch(error => {
          this.$swal({
            type: "error",
            title: "¡Operación no Permitida!",
            text: "Ocurrió un error al obtener los registros.",
            footer: ""
          });
          console.log(error);
          this.$root.$dialogLoader.hide();
        });

      this.dialog = true;
    },
    getEstatus: function(estatus) {
      var arr_estatus = [
        "Pendiente",
        "No Procesado",
        "Correcto",
        "Enviado",
        "Autoasignado",
        "Procesado",
        "Procesado con Errores"
      ];
      if (estatus in arr_estatus) return arr_estatus[estatus];
      else return "N/A";
    },

    parseDate(date) {
      //Formato  YYYY-MM-DD
      if (!date) return null;
      return moment(String(date)).format("YYYY-MM-DD");
    },
    parseDateTime(date) {
      //Formato  YYYY-MM-DD
      if (!date) return null;
      return moment(String(date)).format("YYYY-MM-DD HH:mm:ss");
    },
    downloadFile: function(key) {
      this.$root.$dialogLoader.show("ESPERE UN MOMENTO POR FAVOR..");
      var datos = {
        id: key,
        bucket: "production.econnect.ds"
      };
      axios
        .post(this.$hostname + "s3/download_url/", datos)
        .then(res => {
          if (typeof res.data !== "undefined") {
            var a = document.createElement("a");
            document.body.appendChild(a);
            a.style = "display: none";
            a.href = res.data.mensaje;
            a.target = "_blank";
            a.click();
            a.parentNode.removeChild(a);
          } else {
            this.$swal({
              type: "error",
              title: "¡Operación no Permitida!",
              text:
                "No se encontró el archivo a descargar. Intente nuevamente por favor.",
              footer: ""
            });
          }
        })
        .catch(error => {
          var mensaje = "Ocurrió un error al descargar el archivo";
          if (
            error.response != undefined &&
            error.response.data != undefined &&
            error.response.data.mensaje != undefined
          )
            mensaje = error.response.data.mensaje;
          this.$swal({
            type: "error",
            title: "¡Operación no Permitida!",
            text: mensaje,
            footer: ""
          });
          console.log(error);
        })
        .then(() => {
          this.$root.$dialogLoader.hide();
        });
    },
    getTiposDocumentos: function() {
      var data = {
        tabla: 25
      };
      axios
        .post(this.$hostname + "apendices/lista/", data)
        .then(response => {
          if (response.data != undefined) {
            this.tiposDocumentos = response.data;
            this.tiposDocumentos = this.tiposDocumentos.sort(function(a, b) {
              return a.clave > b.clave;
            });
          }
        })
        .catch(error => {
          console.log(error);
          this.$swal({
            type: "error",
            title: "¡Operación no Permitida!",
            text: "Ocurrió un error al obtener los tipos de documento.",
            footer: ""
          });
        });
    },

    procesarArchivos: function() {
      let self = this;
      let aplicar = false;

      self.archivos.forEach(function(archivo) {
        if (archivo.estatus != 5) {
          if (archivo.estatus < 2) {
            //0-Pendiente, 1-No Procesado
            archivo.tipo_documento = "000";
            archivo.estatus = 4; //4-Autoasignado
          }
          let tipo = archivo.nombre_original.split("_");
          if (tipo.length > 1) {
            var filtro = self.tiposDocumentos.filter(function(e) {
              return e.clave == tipo[0];
            });
            if (filtro.length > 0) {
              archivo.tipo_documento = tipo[0];
              archivo.estatus = 2; //2-Correcto
              archivo.tiene = 1;
            } else {
              aplicar = true;
              archivo.tiene = 0;
            }
          } else {
            aplicar = true;
            archivo.tiene = 0;
          }
          if (aplicar) {
            let arr = self.model.pedimento.split("-");
            self.model.aduana = arr[0];
            self.model.patente = arr[1];
            self.reglas.forEach(function(regla) {
              let extensiones = eval(regla.extensiones);
              let regla_aduanas = eval(regla.aduana);
              let regla_patentes = eval(regla.patente);
              if (
                regla_patentes.includes(self.model.patente.toUpperCase()) ||
                regla_patentes[0] == "TODOS"
              ) {
                console.log("patente");
                if (
                  regla_aduanas.includes(self.model.aduana.toUpperCase()) ||
                  regla_aduanas[0] == "TODOS"
                ) {
                  console.log("aduana");
                  if (
                    regla.perfil == archivo.perfil_usuario ||
                    regla.perfil == "TODOS"
                  ) {
                    console.log("perfil");

                    if (
                      extensiones.includes(
                        archivo.extension.toUpperCase().replace(".", "")
                      ) ||
                      extensiones[0] == "TODOS" ||
                      (extensiones[0] == "NUM" &&
                        parseInt(
                          archivo.extension.toUpperCase().replace(".", "")
                        ) > 0)
                    ) {
                      console.log("ext");

                      console.log("claves-" + archivo.nombre_original);

                      //CUANDO TIENE TODOS
                      if (
                        regla.inicia_con != "" &&
                        regla.contiene != "" &&
                        regla.termina_con != ""
                      ) {
                        if (
                          archivo.nombre_original
                            .toUpperCase()
                            .startsWith(regla.inicia_con.toUpperCase(), 0) &&
                          archivo.nombre_original
                            .toUpperCase()
                            .indexOf(regla.contiene.toUpperCase()) > -1 &&
                          archivo.nombre_original
                            .toUpperCase()
                            .endsWith(regla.termina_con.toUpperCase())
                        ) {
                          archivo.tipo_documento = regla.prefijo_documento;
                          archivo.estatus = 2;
                        }
                      }
                      //CUANDO TIENE INICIO Y CONTIENE
                      if (
                        regla.inicia_con != "" &&
                        regla.contiene != "" &&
                        regla.termina_con == ""
                      ) {
                        if (
                          archivo.nombre_original
                            .toUpperCase()
                            .startsWith(regla.inicia_con.toUpperCase(), 0) &&
                          archivo.nombre_original
                            .toUpperCase()
                            .indexOf(regla.contiene.toUpperCase()) > -1
                        ) {
                          archivo.tipo_documento = regla.prefijo_documento;
                          archivo.estatus = 2;
                        }
                      }
                      //CUANDO TIENE INICIO Y FIN
                      if (
                        regla.inicia_con != "" &&
                        regla.contiene == "" &&
                        regla.termina_con != ""
                      ) {
                        if (
                          archivo.nombre_original
                            .toUpperCase()
                            .startsWith(regla.inicia_con.toUpperCase(), 0) &&
                          archivo.nombre_original
                            .toUpperCase()
                            .endsWith(regla.termina_con.toUpperCase())
                        ) {
                          archivo.tipo_documento = regla.prefijo_documento;
                          archivo.estatus = 2;
                        }
                      }
                      //CUANDO TIENE CONTIENE Y FIN
                      if (
                        regla.inicia_con == "" &&
                        regla.contiene != "" &&
                        regla.termina_con != ""
                      ) {
                        if (
                          archivo.nombre_original
                            .toUpperCase()
                            .indexOf(regla.contiene.toUpperCase()) > -1 &&
                          archivo.nombre_original
                            .toUpperCase()
                            .endsWith(regla.termina_con.toUpperCase())
                        ) {
                          archivo.tipo_documento = regla.prefijo_documento;
                          archivo.estatus = 2;
                        }
                      }
                      //CUANDO TIENE SOLO INICIO
                      if (
                        regla.inicia_con != "" &&
                        regla.contiene == "" &&
                        regla.termina_con == ""
                      ) {
                        if (
                          archivo.nombre_original
                            .toUpperCase()
                            .startsWith(regla.inicia_con.toUpperCase(), 0)
                        ) {
                          archivo.tipo_documento = regla.prefijo_documento;
                          archivo.estatus = 2;
                        }
                      }
                      //CUANDO TIENE SOLO CONTIENE
                      if (
                        regla.inicia_con == "" &&
                        regla.contiene != "" &&
                        regla.termina_con == ""
                      ) {
                        if (
                          archivo.nombre_original
                            .toUpperCase()
                            .indexOf(regla.contiene.toUpperCase()) > -1
                        ) {
                          archivo.tipo_documento = regla.prefijo_documento;
                          archivo.estatus = 2;
                        }
                      }
                      //CUANDO TIENE SOLO FIN
                      if (
                        regla.inicia_con == "" &&
                        regla.contiene == "" &&
                        regla.termina_con != ""
                      ) {
                        if (
                          archivo.nombre_original
                            .toUpperCase()
                            .endsWith(regla.termina_con.toUpperCase())
                        ) {
                          archivo.tipo_documento = regla.prefijo_documento;
                          archivo.estatus = 2;
                        }
                      }
                    }
                  }
                }
              }
            });
          }
        }
      });
      this.guardar(this.model.id);
    },
    getReglas: function() {
      let self = this;
      let data = {
        rfc: self.$local_storage.get("rfc")
      };
      axios
        .post(self.$hostname + "reglas/expediente_proceso/listar_reglas/", data)
        .then(response => {
          self.reglas = response.data;
          this.$root.$dialogLoader.hide();
        })
        .catch(error => {
          console.log(error);
        });
    },
    guardar: function(id) {
      let self = this;
      let invalidos = 0;
      let estatus = 1;
      this.archivos.forEach(function(a) {
        if (a.estatus != 5) {
          if (a.estatus == 2 || a.estatus == 4) {
            if (a.tiene == 0)
              a.nombre_nuevo = a.tipo_documento + "_" + a.nombre_original;
            else a.nombre_nuevo = a.nombre_original;
          } else {
            invalidos = invalidos + 1;
          }
          delete a.tiene;
        }
      });
      if (invalidos == 0) {
        estatus = 2;
      }
      self.model.estatus = estatus;
      let files = this.archivos;
      files.forEach(function(f) {
        delete f.tiene;
      });

      let data = {
        id: id,
        estatus: estatus,
        archivos: files
      };
      axios
        .post(
          this.$hostname + "bandeja_temporal_manifestacion/actualizar/",
          data
        )
        .then(response => {
          console.log(response.data);
        })
        .catch(error => {
          console.log(error);
        });
    },
    enviar: function(id) {
      let self = this;
      this.$root.$dialogLoader.show("ESPERE UN MOMENTO POR FAVOR..");
      this.archivos.forEach(function(a) {
        a.estatus = 3;
      });

      self.model.estatus = 3;
      let data = {
        id: id,
        estatus: 3,
        archivos: this.archivos
      };
      axios
        .post(
          this.$hostname + "bandeja_temporal_manifestacion/actualizar/",
          data
        )
        .then(response => {
          if (response.data) {
            let data2 = {
              id: id,
              id_usuario: parseInt(self.$local_storage.get("id_usuario"))
            };
            axios
              .post(
                this.$hostname + "bandeja_temporal_manifestacion/cargar/",
                data2
              )
              .then(response => {
                if (response.data) {
                  this.$swal({
                    type: "success",
                    title: "¡Operación Realizada!",
                    text: "El envío se realizó correctamente.",
                    footer: ""
                  });
                  self.dialog = false;
                  self.consultar();
                  self.$root.$dialogLoader.hide();
                }
              })
              .catch(error => {
                console.log(error);
              });
          }
        })
        .catch(error => {
          console.log(error);
        });
    }
  },
  created: function() {
    var f = new Date();
    var f_de = new Date();

    f_de.setDate(f_de.getDate() + 1);

    let y_de = f_de.getFullYear();
    let m_de = f_de.getMonth() + 1;
    let d_de = f_de.getDate();

    if (m_de < 10) m_de = "0" + m_de;
    if (d_de < 10) d_de = "0" + d_de;

    let y = f.getFullYear();
    let m = f.getMonth() + 1;
    let d = f.getDate();

    if (m < 10) m = "0" + m;
    if (d < 10) d = "0" + d;

    this.model.fecha_de = y + "-" + m + "-" + d;
    this.model.fecha_a = y_de + "-" + m_de + "-" + d_de;

    // this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
    this.URL = this.$hostname;
    this.model.usuario = this.$local_storage.get("id_usuario");
    this.model.rfc = this.$local_storage.get("rfc");
    var tipoUsuario = this.$local_storage.get("tipo_usuario");
    if (tipoUsuario == "Soporte" || tipoUsuario == "Super Usuario") {
      this.permisoEliminar = true;
    }
    this.getTiposDocumentos();
    this.getReglas();
    this.consultar();
    this.consultar_logs();
  }
};
</script>

<style scoped>
.elevation-1 >>> .vl {
  border-left: 1px solid gray;
  height: auto;
}

.elevation-1 >>> .v-label.theme--light {
  color: black !important;
}

.elevation-1
  >>> div.v-input.theme--light.v-input--selection-controls.v-input--checkbox
  div.v-input__control {
  margin-bottom: -35px;
}

.elevation-1 >>> .v-input--has-state > div:nth-child(1) > div:nth-child(2) {
  margin-top: -10px;
}

.elevation-1
  >>> div.v-input.theme--light.v-input--selection-controls.v-input--checkbox
  div.v-input__control
  div.v-input__slot
  label.v-label.theme--light {
  font-size: 10px !important;
}

.showPerfil {
  cursor: pointer;
  border-bottom: 1px dotted;
}

.showPerfil6 {
  cursor: pointer;
  border-bottom: 1px dotted;
  color: red;
}
.theme--light.v-tabs > .v-tabs-bar .v-tab:not(.v-tab--active),
.theme--light.v-tabs > .v-tabs-bar .v-tab:not(.v-tab--active) > .v-icon,
.theme--light.v-tabs > .v-tabs-bar .v-tab--disabled {
  color: black;
  font-size: small;
  background-color: #eeeeee;
  padding: 0px;
}
.v-tabs .v-tabs-bar .v-tab.v-tab--active {
  color: white;
  font-size: small;
  background-color: #df7205;
  padding: 0px;
  font-weight: bold;
}
.v-tabs-slider-wrapper {
  left: 0 !important;
}
</style>
